if($('body.home').length > 0) {
  const $logo = $('#logo'),
        $header = $('header.top');

  let windowHeight = $(window).height();

  $(window).on('resize', () => {
    windowHeight = $(window).height();
  });

  $(window).on('scroll', () => {
    let scrolled = $(window).scrollTop();
    if(scrolled < (windowHeight * 0.8)) {
      // console.log(scrolled);
      // let scrollPercentage = (scrolled / windowHeight) * 100;
      // console.log(scrollPercentage);
      // $('a.brand').css('bottom', scrollPercentage + '%');

      let widthPercentage = (100 - (scrolled / windowHeight) * 100);
      // console.log(widthPercentage);
      $logo.css('width', widthPercentage + '%');

      if($header.hasClass('show')) {
        $header.removeClass('show');
      }
    } else {
      $header.addClass('show');
    }
  });
}